<template>
  <div>
      <loading :active.sync="isLoading" 
          :can-cancel="true" 
          :is-full-page="fullPage"
          :opacity="1"
          color="#d3a971"
          >
      </loading>
      <MenuHeader v-bind:menu="menu"></MenuHeader>
      <div class="row">
          <MenuSections v-bind:section="section" v-for = "(section, index) in json.data" v-bind:key="index">
          </MenuSections>
      </div>
      <SectionHeader v-bind:section="section" v-for = "(section, index) in json.data" v-bind:key="index">
      </SectionHeader>
      <MenuFooter v-bind:menu="menu"></MenuFooter>
      <button  v-on:click="scrollToTop()" id="scrollTopBtn"><font-awesome-icon icon="angle-up" /></button>
  </div>
</template>

<script>
import MenuHeader from './componentParts/MenuHeader';
import MenuSections from './componentParts/MenuSections';
import SectionHeader from './componentParts/SectionHeader';
import MenuFooter from './componentParts/MenuFooter';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import $ from 'jquery';


export default {
  name: 'DisplayMenu',
  components: {
    MenuHeader,
    MenuSections,
    SectionHeader,
    MenuFooter,
    Loading
  },
  data () {
    return {
      key: '',
      menu: {
        menuImage: '',
        businessLogo: '',
        locationName: '',
        menuName: '',
        menuDescription: '',
        address1: '',
        address2: '',
        city: ''

      },
      json: [],
      isLoading: false,
      fullPage: true
    }
  },
  created () {
    this.isLoading = true;
    const ref = firebase.firestore().collection('spain').doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.key = doc.id;
        this.menu.menuImage = doc.data().menuImage;
        this.menu.businessLogo = doc.data().businessLogo;
        this.menu.locationName = doc.data().locationName;
        this.menu.menuName = doc.data().menuName;
        this.menu.menuDescription = doc.data().menuDescription;
        this.menu.address1 = doc.data().address1;
        this.menu.address2 = doc.data().address2;
        this.menu.city = doc.data().city;
        this.json = JSON.parse(doc.data().menuJsonData);
        setTimeout(() => {
          this.isLoading = false
        },500)

      } else {
        this.$router.push('/') 
        this.isLoading = false;
      }
    });
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll () {
        var $scrollTopBtn = $('#scrollTopBtn');
        $(window).on('scroll', function () {
        if ($(this).scrollTop() > 700) {
            $scrollTopBtn.addClass('actived');
        } else {
            $scrollTopBtn.removeClass('actived');
        }
      })
    },
    scrollToTop: function () {
      $('html, body').animate({
        scrollTop: 0
      }, 500);
    }
  }
}
</script>

<style>
 
</style>